import { Route, Routes } from "react-router-dom";
import Home from "./Pages/HomePage";
import FormulasMath from "../Analytic/Pages/FormulasMath";
import BudgetsManager from "../Analytic/Pages/Budgets/BudgetsManager";
import AccessPage from "./Pages/AccessPage";

function NavBar({ jwt }) {

  return <div>
    <Routes>
      <Route path="/*" element={<Home />} />
      <Route path="/profitability" element={<FormulasMath jwt={jwt} />} />
      <Route path="/budgets" element={<BudgetsManager jwt={jwt} />} />
      <Route path="/access" element={<AccessPage jwt={jwt} />} />
    </Routes>
  </div>;
}

export default NavBar;
